module.exports = __webpack_public_path__ + "static/media/ice-cream-02.7a2d837b.png";